import { useMemo } from 'react';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { SourceRowsTableProps } from './SourceRowsTable.props';

const SourceRowsTable = ({ spreadsheets, onChange, workbook }: SourceRowsTableProps) => {
  const { sourceRowsSheet } = spreadsheets;

  const sourceRowsSheetProps = useMemo(
    () => ({
      ...sourceRowsSheet,
      id: 'source-rows-table',
      tableTerms: { tableSlug: 'source-rows-table' },
      workbook,
      onChange,
      sheet: sourceRowsSheet,
      alwaysDisplayLegend: false,
      disableUnsavedChanges: true,
    }),
    [onChange, sourceRowsSheet, workbook]
  );

  if (!sourceRowsSheet) {
    return null;
  }

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: ScalarSpreadsheet is not typed
    <ScalarSpreadsheet {...sourceRowsSheetProps} className={sourceRowsSheet.name} />
  );
};

export default SourceRowsTable;
